import { Carousel } from 'react-responsive-carousel';
import styled, { css } from 'styled-components';
import theme, { rtlFlip } from 'src/utils/theme';

export const SLIDE_BUTTON_INDENT = theme.sz.s6;
export const SLIDE_BUTTON_SIZE = theme.sz.s11;

export type SlideButtonProps = {
  $buttonType: 'dark' | 'light' | undefined;
};

const tabulation = css`
  li.slide {
    /*
      We've added a delay in visibility changes to ensure that non-selected
      items are still visible during the slide transition
    */
    transition: visibility 0.35s ease-in-out;
    /*
      We've hidden the visibility of non-selected list items to prevent
      users from tabbing to them
    */
    visibility: hidden;
  }

  li.slide.selected {
    visibility: visible;
  }
`;

export const ReactResponsiveCarousel = styled(Carousel)<{ $activeSlideNumber: number }>(
  ({ theme, $activeSlideNumber }) => css`
    .carousel-slider {
      overflow: visible;
    }

    ${tabulation};

    ${theme.rtl &&
    css`
      ul.slider {
        /*
        Copies the default library logic, but does the horizontal shift
        positive since the library out of the box does not support
        right-to-left settings. We use !important the way the library sets
        the value via a style attribute.
        */
        transform: translate3d(
          ${$activeSlideNumber ? $activeSlideNumber * 100 + '%' : '0'},
          0,
          0
        ) !important;
      }
    `}
  `,
);

const SlideButton = styled.button<SlideButtonProps>(
  ({ theme, $buttonType = 'dark' }) => css`
    width: ${SLIDE_BUTTON_SIZE};
    height: ${SLIDE_BUTTON_SIZE};
    /*! @noflip */
    padding: 10px ${theme.sz.s2} 10px ${theme.sz.s3};

    position: absolute;
    top: 50%;
    background: transparent;
    border: ${theme.bo.thinWidth} solid;
    border-radius: ${theme.bo.round};
    cursor: pointer;

    ${$buttonType === 'dark' &&
    css`
      border-color: ${theme.co.neutral0};
      color: ${theme.co.secondary0};
    `}

    ${$buttonType === 'light' &&
    css`
      border-color: ${theme.co.neutral99};
      color: ${theme.co.secondary99};
    `}
  `,
);

export const SlideButtonNext = styled(SlideButton)(
  ({ theme }) => css`
    right: -${SLIDE_BUTTON_INDENT};
    transform: translateY(-50%) translateX(100%) scale(${rtlFlip(theme)});
  `,
);

export const SlideButtonPrev = styled(SlideButton)(
  ({ theme }) => css`
    left: -${SLIDE_BUTTON_INDENT};
    transform: translateY(-50%) translateX(-100%) scale(calc(${rtlFlip(theme)} * -1));
  `,
);
